import { siteConfig } from '@/mocks/data';

export default function WhatsAppButton() {
  const whatsappHref = `https://wa.me/${siteConfig.whatsappNumber}?text=${encodeURIComponent('Merhaba, Atak Sistem Enerji web siteniz üzerinden ulaşıyorum. Fineco Isı Pompası hakkında bilgi ve fiyat almak istiyorum.')}`;

  return (
    <a
      href={whatsappHref}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 z-50 flex items-center gap-2 bg-[#25D366] text-white px-4 py-3 rounded-full shadow-lg hover:scale-105 transition-transform whitespace-nowrap"
      aria-label="WhatsApp'tan Bilgi Al"
    >
      <i className="ri-whatsapp-line text-xl w-5 h-5 flex items-center justify-center"></i>
      <span className="text-sm font-medium hidden sm:inline">Bilgi Al</span>
    </a>
  );
}